<template>
<td v-if="!dataItem.inEdit" :class="className">{{ dataItem[field]}}</td>
<td v-else><dropdownlist :style="'width:'+sirina+'px;'"  @change="change" :data-items='sifrantData' :text-field="'naziv'" :class="customClass" :value="selectedValue" ></dropdownlist></td>

</template>
<script>
import { DropDownList } from '@progress/kendo-vue-dropdowns';


export default {
      components: {
  'dropdownlist': DropDownList,

    },
    props: {

        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sifrantData:Array, 
        selectedValue:Object,
        customClass:String

           },
    
    watch: {
    "dataItem": function (newVal,oldVal) {
      console.log("Change of sifrant!!!")
    //  this.selectedValue=this.sifrantData.find(i=>i.id==newVal);//{id:val.statuspridelkaid,naziv:val.statuspridelkanaziv};
    }
    },
    computed:{
        sirina(){
            //console.log("sirina sifranta "+Math.min([(Math.max(...this.sifrantData.map(i=>i.naziv.length))),20]))
            //console.log("sirina sifranta "+(Math.max(...this.sifrantData.map(i=>i.naziv.length))*10+40))
            return Math.min((Math.max(...this.sifrantData.map(i=>i.naziv.length))),17)*10+40;
            //return Math.max(...this.sifrantData.map(i=>i.naziv.length))*10+40;
        }
    },

    methods: {
        change(e) {
             this.$emit('change', e, this.dataItem, e.value);
        }
    }
}
</script>